import { render, staticRenderFns } from "./ListBoosts.vue?vue&type=template&id=2df2aa9d"
import script from "./ListBoosts.vue?vue&type=script&lang=js"
export * from "./ListBoosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports